<template>
    <div>
        <dx-grid
            url="ykCampDistributionLogs"
            :columns="columns"
            :title="title"
            ref="grid"
            :onLoaded="mapResults"
        ></dx-grid></div
></template>
<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Logs",
        columns: [
            {
                label: "Family ID",
                field: "familyID",
                visible: true,
                filterValues: [],
                link: "YkCampFamilyView",
                template: "link-cell-template",
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "playName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameY",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Site",
                field: "site",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Bungalow",
                field: "bungalow",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Type",
                field: "type",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Source",
                field: "source",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "User",
                field: "userName",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Data",
                field: "data",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
        ],

        actions: [],
        menuItems: [],
    }),
    async created() {
        this.user = this.$store.state.authentication.user;

        await this.loadMenu();
    },
    mounted() {},
    methods: {
        async loadMenu() {
            const response = await this.$http.get(
                "api/campDistribution/getMenuItems"
            );

            this.menuItems = response;
        },
        mapResults(results) {
            return results.map((log) => {
                log.data =
                    this.getLogItem(log) + " | " + this.getLogItemChoice(log);

                return log;
            });
        },
        getLogItem(log) {
            const parts = log.data.split("|");
            const item = parts.find((p) => p.startsWith("MenuItemID"));
            const menuItemID = item.split(":")[1];

            return this.menuItems.find((m) => m.id == +menuItemID).name;
        },
        getLogItemChoice(log) {
            const parts = log.data.split("|");
            const item = parts.find((p) => p.startsWith("Choice"));
            return item.split(":")[1];
        },
    },
};
</script>
